let adapted = false

const listeners = new Set<() => void>()

/** Called when the dark-adaptation intro starts to lift, or straight away when it is skipped. */
export const markAdapted = (): void => {
    if (adapted) return

    adapted = true
    listeners.forEach(listener => listener())
    listeners.clear()
}

export const onAdapted = (listener: () => void): (() => void) => {
    if (adapted) {
        listener()
        return () => undefined
    }

    listeners.add(listener)

    return () => {
        listeners.delete(listener)
    }
}

export const isAdapted = (): boolean => adapted
